import React from "react";

import { useTranslation } from "react-i18next";

import styled from "styled-components";

import { TFunction } from "i18next";
import { SettingsAIChatBotShareDrawerScript } from "./SettingsAIChatBotShareDrawerScript";
import { SettingsAIChatBotShareDrawerHTML } from "./SettingsAIChatBotShareDrawerHTML";
import { Rounded } from "../../../../../theme/Rounded";
import { Spacing } from "../../../../../theme/Spacing";
import { AtiraTabs } from "../../../../../components/AtiraTabs";
import { useSettingsAIChatbotContext } from "../../../sections/SettingsAIChatBot";
import { Drawer } from "../../../../../components/Drawer";

const getShareTabs = (t: TFunction) => [
  {
    key: "script",
    label: t("settings.aiChatbot.share.tabs.script.title"),
    children: <SettingsAIChatBotShareDrawerScript />,
  },
  {
    key: "html",
    label: t("settings.aiChatbot.share.tabs.html.title"),
    children: <SettingsAIChatBotShareDrawerHTML />,
  },
];

const StyledTabs = styled(AtiraTabs)`
  padding-inline: 0 !important;

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-nav-list {
    gap: ${Spacing.xs};
  }

  .ant-tabs-tab {
    justify-content: center;
    border-color: transparent;
    border-radius: ${Rounded.md} ${Rounded.md} 0 0;
  }

  .ant-tabs-content-holder {
    border: 2px solid ${({ theme }) => theme.main};
    border-radius: ${Rounded.md};
    padding: ${Spacing.m};
  }

  &:has(.ant-tabs-tab:nth-child(1).ant-tabs-tab-active)
    .ant-tabs-content-holder {
    border-start-start-radius: 0;
  }

  &:has(.ant-tabs-tab:nth-child(1):hover) .ant-tabs-content-holder {
    border-start-start-radius: 0;
  }
`;

const SettingsAIChatBotShareDrawer: React.FC = () => {
  const { t } = useTranslation();
  const {
    currentBot,
    shareDrawerOpen: open,
    toggleShareDrawerOpen: onClose,
  } = useSettingsAIChatbotContext();

  if (!currentBot) {
    return null;
  }

  return (
    <Drawer
      title={t("common.share")}
      open={open}
      onClose={onClose}
      size="large"
    >
      <StyledTabs items={getShareTabs(t)} />
    </Drawer>
  );
};

export default SettingsAIChatBotShareDrawer;
